import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import { marked } from "marked";
import DOMPurify from "dompurify";
import axios from "axios";
import PropTypes from "prop-types";
import { API_BASE_URL, LAMBDA_BASE_URL } from "../../../constants";
import { getDomainIdSync } from "utils/utils";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const Readmore = ({ text, apiEndpoint, id }) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [originalText, setOriginalText] = useState(text);
  const [editedText, setEditedText] = useState(text);
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);

  useEffect(() => {
    setOriginalText(text);
    setEditedText(text);
  }, [text]);

  const openDialog = () => {
    setIsDialogOpen(true);
    setIsEditing(false);
    setEditedText(originalText);
  };

  const closeDialog = () => {
    setIsDialogOpen(false);
    setIsEditing(false);
    setEditedText(originalText);
  };

  const openConfirmationDialog = () => setIsConfirmationOpen(true);
  const closeConfirmationDialog = () => setIsConfirmationOpen(false);

  const handleSave = async () => {
    try {
      const domainId = getDomainIdSync() || localStorage.getItem("domainId");
      const response = await axios.patch(
        `${LAMBDA_BASE_URL}/edit-answer/${id}`,
        { id, answer: editedText },
        { headers: { "DOMAIN-TOKEN": domainId } }
      );

      if (response.status === 200) {
        setOriginalText(editedText);
        setIsEditing(false);
        setIsConfirmationOpen(false);
      }
    } catch (error) {
      console.error("Error updating the answer:", error.response?.data || error.message);
    }
  };

  return (
    <>
      <Button
        onClick={openDialog}
        style={{
          background: "#219297",
          color: "white",
          border: "none",
          fontWeight: 500,
          fontSize: "10px",
          lineHeight: "12px",
          borderRadius: "4px",
          padding: "8px",
        }}
      >
        Edit Answer
      </Button>

      <Dialog
        open={isDialogOpen}
        onClose={closeDialog}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>Answer</DialogTitle>
        <DialogContent dividers sx={{ padding: "32px" }}>
         
            <ReactQuill
              theme="snow"
            value={marked.parse(editedText)}
              onChange={setEditedText}
              style={{
                minHeight: "200px",
              }}
              placeholder="Enter your answer..."
            />
    
        </DialogContent>

        <DialogActions>
          
            <>
              <Button
                onClick={openConfirmationDialog}
                variant="contained"
                sx={{
                  background: "teal",
                  color: "#fff",
                  textTransform: "none",
                  fontWeight: 600,
                  "&:hover": { background: "teal" },
                }}
              >
                Save Changes
              </Button>
              {/* <Button
                onClick={() => {
                  setIsEditing(false);
                  setEditedText(originalText);
                }}
                // variant="outlined"
                sx={{color:"#000000",borderColor:"#219297"}}
            
              >
                Cancel
              </Button> */}
            </>
      
           
          <Button sx={{ color: "#219297" }} onClick={closeDialog}>
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={isConfirmationOpen} onClose={closeConfirmationDialog} fullWidth maxWidth="sm">
        <DialogTitle>Confirm Save</DialogTitle>
        <DialogContent sx={{ paddingTop: "16px" }}>
          <p>Are you sure you want to save the changes?</p>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeConfirmationDialog}>Cancel</Button>
          <Button
            onClick={handleSave}
            variant="contained"
            sx={{
              background: "teal",
              color: "#fff",
              textTransform: "none",
              fontWeight: 600,
              "&:hover": { background: "teal" },
            }}
          >
            Yes, Save
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

Readmore.propTypes = {
  text: PropTypes.string.isRequired,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  apiEndpoint: PropTypes.string,
};

export default Readmore;
